const crew = {
  tenants: {
    view: 'deny',
    edit: 'deny',
    list: 'deny',
    create: 'deny',
  },
  users: {
    view: 'deny',
    edit: 'deny',
    list: 'deny',
    create: 'adeny',
  },
  clients: {
    view: 'deny',
    edit: 'deny',
    list: 'deny',
    create: 'deny',
  },
  estimates: {
    view: 'deny',
    edit: 'deny',
    list: 'deny',
    create: 'deny',
  },
  servicerequests: {
    view: 'deny',
    edit: 'deny',
    list: 'deny',
    create: 'deny',
  },
  dashboard: {
    view: 'allow',
    edit: 'allow',
    list: 'allow',
    create: 'allow',
  },
  myForest: {
    view: 'allow',
    edit: 'allow',
    list: 'allow',
    create: 'allow',
  },
  schedules: {
    view: 'allow',
    edit: 'allow',
    list: 'allow',
    create: 'allow',
  },
  workorders: {
    view: 'allow',
    edit: 'allow',
    list: 'allow',
    create: 'allow',
    assign: 'deny',
    schedule: 'deny',
    amount: 'deny',
  },
  jobs: {
    view: 'deny',
    edit: 'deny',
    list: 'deny',
    create: 'deny',
  },
  jobSites: {
    view: 'deny',
    edit: 'deny',
    list: 'deny',
    create: 'deny',
  },
  workcategories: {
    view: 'allow',
    edit: 'allow',
    list: 'allow',
    create: 'allow',
  },
  worktypes: {
    view: 'allow',
    edit: 'allow',
    list: 'allow',
    create: 'allow',
  },
  invoices: {
    view: 'deny',
    edit: 'deny',
    list: 'deny',
    create: 'deny',
  },
  trees: {
    edit: 'allow',
    create: 'allow',
    view: 'allow',
  },
  crews: {
    edit: 'deny',
    create: 'deny',
    view: 'deny',
    list: 'deny',
  },
  species: {
    edit: 'allow',
    create: 'allow',
    view: 'allow',
    list: 'allow',
  },
  speciesadmin: {
    edit: 'deny',
    create: 'deny',
    view: 'deny',
    list: 'deny',
  },
  tenantsettings: {
    edit: 'deny',
    create: 'deny',
    view: 'deny',
    list: 'deny',
  },
  catalog: {
    edit: 'deny',
    create: 'deny',
    view: 'deny',
    list: 'deny',
  },
  subscription: {
    edit: 'deny',
    create: 'deny',
    view: 'deny',
    list: 'deny',
  },
  tools: {
    edit: 'deny',
  },
  seed: {
    edit: 'deny',
  },
};

export {crew};
